import React from "react";
import TablesFactures from "./features/TablesFactures";
import { Help } from "src/utils";
import { NumberToLetter } from "@mandarvl/convertir-nombre-lettre";
import { SectionFacture } from "../../compoments/ModalDelete";
export default function FactureLoyer({ cost }) {
  const infoDataTableHead = [
    {
      libelle: "LIBELLE",
    },
    {
      libelle: "MONTANT UNITAIRE",
    },
    {
      libelle: "TOTAL",
    },
  ];
  const infoDataTableBody = [
    {
      className: "border-top  border-dark",
      coloneTd: [
        {
          libelle: `LOYER:`,
        },
        {
          libelle: Help.convertInMoney(Number(cost)),
        },
        {
          libelle: Help.convertInMoney(Number(cost)),
        },
      ],
    },
    {
      className: "border-bottom border-dark",
      coloneTd: [
        {
          libelle: `TOTAL A PAYER`,
          colSpan: 2,
          style: "text-left",
        },
        {
          libelle: Help.convertInMoney(Number(cost)),
        },
      ],
    },
  ];
  return (
    <section className="my-5">
      <TablesFactures
        infoDataTableBody={infoDataTableBody}
        infoDataTableHead={infoDataTableHead}
      />
      <SectionFacture
        styleName={"px-5 my-5"}
        DataParagaphe={[
          {
            libelle: ` Arrêtée la présente facture à la somme de : `,
          },
          {
            libelle: `${NumberToLetter(Number(cost))}`,
            styleParagraphe: "facture_in_somme text-secondary",
          },
        ]}
      />
    </section>
  );
}
